import _ from 'lodash';
import React from 'react';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';

import { DeleteButton } from 'client/shared/components';

@inject('albumsStore', 'artistStore')
@observer

//TODO: On Admin Side, this throws a weird error I can't understand yet
class AlbumRow extends React.Component {
	render () {
		const { album, albumsStore } = this.props;
		return (
			<div className="cell large-2 medium-4 small-6">
				<div className="grid-x">
					<div className="cell small-12">
						<div className="image medium"
							style={{ backgroundImage: `url("${album.artworkPath}")`, cursor: 'pointer' }}
							onClick={ this.openEditModal }
						></div>
					</div>
					<div className="cell small-12">
						<h5 className="margin-top-1 album-title" style={{maxWidth:'11.5rem'}}>
							{ album.name }
						</h5>
					</div>
					<div className="cell small-1">
						<button
							className="button clear padding-left-0 padding-top-0"
							onClick={ this.openEditModal }
						>
							<span className="fal fa-pencil-alt"></span>
						</button>
					</div>
					<div className="cell small-1">
						<DeleteButton
							warningText="Really delete this album?"
							onConfirmClick={ this.onConfirmClick }
						>
							<button className="button secondary clear margin-bottom-0 padding-top-0">
								<span className="fi-trash icon padding-0"></span>
							</button>
						</DeleteButton>
					</div>
				</div>
			</div>
		);
	}

	@autobind
	openEditModal () {
		const { albumsStore, album } = this.props;

		albumsStore.albumModalOpen = true;
		albumsStore.modalEditAlbum = album;
	}

	getBackgroundImage () {
		const { album: { artworkPath, artistID }, artistStore, rowUserID } = this.props;

		const imagePath = artworkPath;
		const backgroundImage = `url("${imagePath}")`;

		return backgroundImage;
	}

	@autobind
	onConfirmClick () {
		const { album } = this.props;
		album.delete();
	}
}

export default AlbumRow;
